import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Table from "../../../../core/pagination/datatable";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import { Select, Spin } from "antd";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { RotateCcw } from "feather-icons-react/build/IconComponents";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import { Payroll_API_BASE_URL } from "../PConfig/PConfig";
import Swal from "sweetalert2";


const CombinedProcessPayroll = () => {
  // const [dataLoading, setDataLoading] = useState(false);
  const [currentStep, setCurrentStep] = useState(1);
  const [showProcessedTable, setShowProcessedTable] = useState(false);

  console.log(showProcessedTable);
  const [dataLoading, setDataLoading] = useState(false);
  console.log("dataLoading", setDataLoading);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [branchesList, setBranchesList] = useState([]);
  const [SelectedBranchId, setSelectedBranchId] = useState(null);
  const [PayPeriodlist, setPayPeriodlist] = useState([]);
  console.log(PayPeriodlist, "iudhuisdhsiuhasiudaiadhsadha")
  const [selectedPayPeriod, setSelectedPayPeriod] = useState(null);
  console.log(selectedPayPeriod, "selectedPayPeriod");
  const [importedAttendanceData, setImportedAttendanceData] = useState([]);
  const [processedData, setProcessedData] = useState([]);
  const navigate = useNavigate();
  const attendanceData = [
    {
      key: 1,
      employeeid: 1001,
      employee: "Ravi Kumar",
      department: "HR",
      workingdays: 30,
      presentdays: 24,
      absentdays: 3,
      leaves: 1,
      weekoff: 2,
      othrs: 12,
      lesshrs: 2,
    },
    {
      key: 2,
      employeeid: 1002,
      employee: "Anjali Sharma",
      department: "Finance",
      workingdays: 30,
      presentdays: 24,
      absentdays: 2,
      leaves: 2,
      weekoff: 2,
      othrs: 15,
      lesshrs: 3,
    },
    {
      key: 3,
      employeeid: 1003,
      employee: "Suresh Reddy",
      department: "IT",
      workingdays: 30,
      presentdays: 24,
      absentdays: 1,
      leaves: 1,
      weekoff: 4,
      othrs: 18,
      lesshrs: 1,
    },
    {
      key: 4,
      employeeid: 1004,
      employee: "Neha Verma",
      department: "Operations",
      workingdays: 30,
      presentdays: 24,
      absentdays: 2,
      leaves: 3,
      weekoff: 1,
      othrs: 10,
      lesshrs: 4,
    },
    {
      key: 5,
      employeeid: 1005,
      employee: "Amit Patel",
      department: "Sales",
      workingdays: 30,
      presentdays: 24,
      absentdays: 1,
      leaves: 1,
      weekoff: 4,
      othrs: 14,
      lesshrs: 1,
    },
  ];


  const attendanceColumns = [
    { title: "Badge", dataIndex: "Badge" },
    { title: "Employee",
       dataIndex: "UserName",
       render: (text) => (
    <span title={text}>
      {text?.length > 15 ? `${text.slice(0, 15)}...` : text}
    </span> 
  )
    },
    { title: "Department", dataIndex: "Department",
       render: (text) => (
    <span title={text}>
      {text?.length > 15 ? `${text.slice(0, 15)}...` : text}
    </span> 
  )
     },
    { title: "Working Days", dataIndex: "WorkingDays" },
    { title: "Present", dataIndex: "PresentDays" },
    { title: "Absent", dataIndex: "Absents" },
    { title: "Leaves", dataIndex: "Leaves" },
    { title: "WeekOff", dataIndex: "MonWeekOffs" },
    { title: "OT Hrs", dataIndex: "OtTime" },
    { title: "Less Hrs", dataIndex: "LessHrs" },
  ];

  const payrollColumns = [
    { title: "Badge", dataIndex: "Badge" },
    { title: "Employee",
      dataIndex: "Username",
     render: (text) => (
    <span title={text}>
      {text?.length > 15 ? `${text.slice(0, 15)}...` : text}
    </span> 
  )
 },
    { title: "Designation",
       dataIndex: "Designation",
        render: (text) => (
    <span title={text}>
      {text?.length > 15 ? `${text.slice(0, 15)}...` : text}
    </span> 
  )
       },
    { title: "Basic", dataIndex: "Basic" },
    { title: "HRA", dataIndex: "Hra" },
    { title: "Conveyance", dataIndex: "ConveyanceAllowance" },
    { title: "Total Deduct", dataIndex: "Deductions" },
    { title: "Net Pay", dataIndex: "NetPayble" },
  ];


  const [data] = useState(attendanceData);

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleReload = () => {
    window.location.reload();
  };

  const handleDownloadExcel = () => {
    if (data.length === 0) return;

    const wb = XLSX.utils.book_new();
    const wsData = data.map((item, index) => ({
      "S.No": index + 1,
      Employee: item.employee,
      "Emp Code": item.empCode,
      "Monthly Salary": item.monthlySalary,
      "Yearly CTC": item.yearlyCTC,
      Group: item.group,
      "Start Date": formatDate(item.startDate),
      "End Date": formatDate(item.endDate),
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Annual CTC");
    XLSX.writeFile(wb, "Employee_Annual_CTC.xlsx");
  };

  const generatePDF = () => {
    if (data.length === 0) return;

    const doc = new jsPDF();
    doc.text("Employee Annual CTC Report", 14, 10);

    const tableColumn = [
      "S.No",
      "Employee",
      "Emp Code",
      "Monthly Salary",
      "Yearly CTC",
      "Group",
      "Start Date",
      "End Date",
    ];
    const tableRows = data.map((item, index) => [
      index + 1,
      item.employee,
      item.empCode,
      `$${item.monthlySalary.toLocaleString()}`,
      `$${item.yearlyCTC.toLocaleString()}`,
      `$${item.group.toLocaleString()}`,
      formatDate(item.startDate),
      formatDate(item.endDate),
    ]);

    doc.autoTable({ head: [tableColumn], body: tableRows, startY: 20 });
    doc.save("Employee_Annual_CTC.pdf");
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      PDF
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    // const superId = sessionStorage.getItem("superId");
    const superId = sessionStorage.getItem("PayrollSuperId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      const fetchBranchsList = async () => {
        try {
          const response = await fetch(
            `${Payroll_API_BASE_URL}portal/branch/getbranch?superid=${superIdData}`,
            {
              headers: {
                "Content-Type": "application/json",
                // Authorization: `Bearer ${tokenData}`,
                Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,

              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch Branches");
          }

          const data = await response.json();

          if (data.status) {
            setBranchesList(data.ResultData);
          } else {
            console.error("Invalid Branches response structure:", data);
          }
        } catch (error) {
          console.error("Error fetching BranchesList:", error.message);
        }
      };
      fetchBranchsList();
    }
  }, [superIdData, tokenData]);

  useEffect(() => {
    if (tokenData && superIdData && SelectedBranchId) {
      const fetchPayPeriodsList = async () => {
        setDataLoading(true);
        setPayPeriodlist([]); // reset old data

        try {
          const response = await fetch(
            `${Payroll_API_BASE_URL}payroll/Process/getPayPeriod?SuperId=${superIdData}&BranchId=${SelectedBranchId}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
              },
            }
          );

          if (!response.ok) {
            throw new Error("Failed to fetch Pay Periods");
          }

          const data = await response.json();

          if (data.status && data.ResultData.length > 0) {
            const sorted = [...data.ResultData].sort(
              (a, b) => new Date(b.StartDate) - new Date(a.StartDate)
            );

            setPayPeriodlist(sorted);

            const latestPeriod = sorted[0];

            setSelectedPayPeriod({
              label: latestPeriod.Name,
              value: latestPeriod.PayPeriodId,
              data: latestPeriod,
            });
          } else {
            setPayPeriodlist([]);
          }
        } catch (error) {
          console.error("Error fetching PayPeriodList:", error.message);
          setPayPeriodlist([]);
        } finally {
          setDataLoading(false);
        }
      };

      fetchPayPeriodsList();
    }
  }, [superIdData, tokenData, SelectedBranchId]);

  const handleAttendanceAction = async () => {
    if (!selectedPayPeriod || !SelectedBranchId) return;

    const isSubmitted = selectedPayPeriod.data?.IsAttendanceSubmitted;

    if (isSubmitted) {
      try {
        setDataLoading(true);

        const url = `${Payroll_API_BASE_URL}payroll/Process/PayrollImportedAttendance?SuperId=${superIdData}&PayPeriodId=${selectedPayPeriod.value}&IsInsertInToAttendance=0&BranchId=${SelectedBranchId}`;

        const response = await fetch(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
          },
        });

        const data = await response.json();
        console.log("Attendance data:", data);
        setImportedAttendanceData(data.ResultData || []);

      } catch (error) {
        console.error(error);
      } finally {
        setDataLoading(false);
      }

      return;
    }
    const result = await Swal.fire({
      title: "Import Attendance?",
      text: "This will import attendance for the selected pay period.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Import",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#3085d6",
    });

    if (!result.isConfirmed) return;

    try {
      setDataLoading(true);

      const url = `${Payroll_API_BASE_URL}payroll/Process/PayrollImportedAttendance?SuperId=${superIdData}&PayPeriodId=${selectedPayPeriod.value}&IsInsertInToAttendance=1&BranchId=${SelectedBranchId}`;

      const response = await fetch(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
        },
      });

      const responseData = await response.json();
      console.log("Attendance response:", responseData);

      Swal.fire("Success", "Attendance imported successfully", "success");
      setSelectedPayPeriod((prev) => ({
        ...prev,
        data: {
          ...prev.data,
          IsAttendanceSubmitted: true,
        },
      }));
    } catch (error) {
      Swal.fire("Error", "Failed to import attendance", "error");
    } finally {
      setDataLoading(false);
    }
  };

  const handlePayrollAction = async () => {
    if (!selectedPayPeriod || !SelectedBranchId) return;

    if (isPayrollProcessed) {
      try {
        setDataLoading(true);

        const url = `${Payroll_API_BASE_URL}payroll/Process/GetEmployeePayReport?PayPeriodId=${selectedPayPeriod.value}&BranchId=${SelectedBranchId}`;

        const response = await fetch(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
          },
        });

        const data = await response.json();
        console.log("Processed payroll data:", data);
        setProcessedData(data.ResultData || []);
      } catch (error) {
        console.error(error);
      } finally {
        setDataLoading(false);
      }
      return;
    }

    const result = await Swal.fire({
      title: "Process Payroll?",
      text: "This will process payroll for the selected pay period.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Process",
      cancelButtonText: "Cancel",
    });

    if (!result.isConfirmed) return;

    try {
      setDataLoading(true);

      const url = `${Payroll_API_BASE_URL}payroll/Process/PayrollProcessBranchWise?ProcessingUser=2&PayperiodId=${selectedPayPeriod.value}&BranchId=${SelectedBranchId}`;

      const response = await fetch(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer FFC10000-022A-4030-0000-DA26AE3BA419-3`,
        },
      });

      const data = await response.json();

      if (data.status) {
        Swal.fire("Success", "Payroll processed successfully", "success");

        setSelectedPayPeriod((prev) => ({
          ...prev,
          data: {
            ...prev.data,
            IsPayRollProcessed: true,
          },
        }));

        await handlePayrollAction();
      } else {
        Swal.fire("Error", data.message || "Payroll failed", "error");
      }
    } catch (error) {
      Swal.fire("Error", "Payroll processing failed", "error");
    } finally {
      setDataLoading(false);
    }
  };


  const BranchesOptions = branchesList?.map((branch) => ({
    label: branch.Name,
    value: branch.branchid,
  })) || [];

  const PayperiodOptions = PayPeriodlist.map(period => ({
    label: period.Name,
    value: period.PayPeriodId,
    data: period,
  }));


  const isAttendanceSubmitted =
    selectedPayPeriod?.data?.IsAttendanceSubmitted;
  console.log(isAttendanceSubmitted, "isAttendanceSubmitted");

  const attendanceButtonText = isAttendanceSubmitted
    ? "View Attendance"
    : "Import Attendance";

  const isPayrollProcessed =
    selectedPayPeriod?.data?.IsPayRollProcessed;

  const payrollButtonText = isPayrollProcessed
    ? "View Payroll"
    : "Process Payroll";
  //     console.log(
  //   "Selected PayPeriod:",
  //   selectedPayPeriod?.label,
  //   "IsAttendanceSubmitted:",
  //   selectedPayPeriod?.data?.IsAttendanceSubmitted
  // );

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header m-2">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Process PayRoll
                    </h4>
                  </ol>
                </nav>
                <h6>Manage your Process PayRoll here</h6>
              </div>
            </div>
            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip}>
                  <Link onClick={generatePDF}>
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="PDF"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                  <Link onClick={handleDownloadExcel}>
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="Excel"
                    />
                  </Link>
                </OverlayTrigger>
              </li>
              <li onClick={handleReload}>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link>
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>
          <div className="">
            <div className="card">
              <div className="card-body pt-1">

                <ul className="nav nav-tabs nav-tabs-bottom mb-1">
                  <li className="nav-item">
                    <Link
                      to="#"
                      className={`nav-link ${currentStep === 1 ? "active" : ""}`}
                      onClick={(e) => {
                        e.preventDefault();
                        setCurrentStep(1);
                        setShowProcessedTable(false);
                      }}
                    >
                      Step 1
                    </Link>
                  </li>

                  <li className="nav-item">
                    <Link
                      to="#"
                      className={`nav-link ${currentStep === 2 ? "active" : "disabled"}`}
                      onClick={(e) => e.preventDefault()}
                    >
                      Step 2
                    </Link>
                  </li>
                </ul>

                {/* Tab Content */}
                <div className="tab-content">

                  {currentStep === 1 && (
                    <div className="tab-pane fade show active" >
                      <div className="row align-items-center g-3 ms-2">
                        {/* Branch */}
                        <div className="col-md-2">
                          <label className="form-label">Branch</label>
                          <Select
                            showSearch
                            placeholder="Select Branch"
                            value={SelectedBranchId}
                            onChange={(val) => {
                              setSelectedBranchId(val);
                              setSelectedPayPeriod(null);
                              setPayPeriodlist([]);
                            }}
                            options={BranchesOptions}
                            style={{ width: 170, height: 37 }}
                          />
                        </div>


                        {/* Pay Period */}
                        <div className="col-md-2">
                          <label className="form-label">Pay Period</label>
                          <Select
                            showSearch
                            labelInValue
                            placeholder="Choose PayPeriod"
                            value={selectedPayPeriod}
                            onChange={(option) => {
                              const fullPeriod = PayPeriodlist.find(
                                (p) => p.PayPeriodId === option.value
                              );

                              setSelectedPayPeriod({
                                label: option.label,
                                value: option.value,
                                data: fullPeriod,
                              });
                            }}
                            options={PayperiodOptions}
                            style={{ width: 170, height: 37 }}
                            filterOption={(input, option) =>
                              option?.label?.toLowerCase().includes(input.toLowerCase())
                            }
                          />
                        </div>

                        {/* Button */}
                        <div className="col-md-2 d-flex align-items-center">
                          <button
                            className={`btn ${isAttendanceSubmitted ? "btn-info" : "btn-primary"
                              } mt-4`}
                            onClick={handleAttendanceAction}
                            disabled={!SelectedBranchId || !selectedPayPeriod || dataLoading}
                          >
                            <i
                              className={`fas ${isAttendanceSubmitted ? "fa-eye" : "fa-upload"
                                } me-1`}
                            ></i>
                            {attendanceButtonText}
                          </button>

                        </div>
                      </div>
                    </div>
                  )}

                  {/* STEP 2 */}
                  {currentStep === 2 && (
                    <div className="tab-pane show active">
                      <div className="row align-items-center g-3 ms-2">
                        <div className="col-md-2">
                          <label className="form-label">Branch</label>
                          <Select
                            showSearch
                            placeholder="Select Branch"
                            value={SelectedBranchId}
                            onChange={(val) => {
                              setSelectedBranchId(val);
                              setSelectedPayPeriod(null);
                              setPayPeriodlist([]);
                            }}
                            options={BranchesOptions}
                            style={{ width: 170, height: 37 }}
                          />
                        </div>


                        {/* Pay Period */}
                        <div className="col-md-2">
                          <label className="form-label">Pay Period</label>
                          <Select
                            showSearch
                            labelInValue
                            placeholder="Choose PayPeriod"
                            value={selectedPayPeriod}
                            onChange={(option) => {
                              const fullPeriod = PayPeriodlist.find(
                                (p) => p.PayPeriodId === option.value
                              );

                              setSelectedPayPeriod({
                                label: option.label,
                                value: option.value,
                                data: fullPeriod,
                              });
                            }}
                            options={PayperiodOptions}
                            style={{ width: 170, height: 37 }}
                            filterOption={(input, option) =>
                              option?.label?.toLowerCase().includes(input.toLowerCase())
                            }
                          />
                        </div>

                        {/* Button */}
                        <div className="col-md-2 d-flex align-items-center">
                          <button
                            className={`btn ${isPayrollProcessed ? "btn-info" : "btn-success"
                              } mt-4`}
                            onClick={handlePayrollAction}
                            disabled={!SelectedBranchId || !selectedPayPeriod || dataLoading}
                          >
                            <i
                              className={`fas ${isPayrollProcessed ? "fa-eye" : "fa-money-check-alt"
                                } me-1`}
                            ></i>
                            {payrollButtonText}
                          </button>
                        </div>

                      </div>
                    </div>
                  )}

                </div>
              </div>
            </div>
          </div>
          {currentStep === 1 && (
            <>
              <div className="card table-list-card">
                <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                  <div className="search-set">
                    <div className="search-input">
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                      />
                      <Link to className="btn btn-searchset">
                        <i data-feather="search" className="feather-search" />
                      </Link>
                    </div>
                  </div>
                  <div className="d-flex right-content align-items-end ">
                    {/* <div className="">
                      <div
                        className="form-control p-0 border-0"
                        style={{ width: 200 }}
                      >
                        <Select
                          showSearch
                          placeholder="Pay Period"
                          filterOption={(input, option) =>
                            option?.label
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          style={{ width: 170, height: 37 }}
                        />
                      </div>
                    </div>
                    <div className="">
                      <div
                        className="form-control p-0 border-0"
                        style={{ width: 200 }}
                      >
                        <Select
                          showSearch
                          placeholder="Branch"
                          filterOption={(input, option) =>
                            option?.label
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          style={{ width: 170, height: 37 }}
                        />
                      </div>
                    </div> */}
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive brand-table">
                    {dataLoading ? (
                      <div className="text-center my-4">
                        <Spin size="large" />
                        <p className="mt-2">Loading attendance...</p>
                      </div>
                    ) : (
                      <Table
                        columns={attendanceColumns}
                        dataSource={importedAttendanceData}
                        rowKey="key"
                        pgno={true}
                      />
                    )}
                  </div>

                </div>

              </div>
              <div className="d-flex justify-content-end mt-3">
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    setCurrentStep(2);
                  }}
                >
                  Next →
                </button>
              </div>
            </>
          )}
          {currentStep === 2 && (
            <>
              <div className="card table-list-card">
                <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                  <div className="search-set">
                    <div className="search-input">
                      <input
                        type="text"
                        placeholder="Search"
                        className="form-control form-control-sm"
                      />
                      <Link to className="btn btn-searchset">
                        <i data-feather="search" className="feather-search" />
                      </Link>
                    </div>
                  </div>
                  <div className="d-flex right-content align-items-end ">
                    {/* <div className="">
                      <div
                        className="form-control p-0 border-0"
                        style={{ width: 200 }}
                      >
                        <Select
                          showSearch
                          placeholder="Pay Period"
                          filterOption={(input, option) =>
                            option?.label
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          style={{ width: 170, height: 37 }}
                        />
                      </div>
                    </div>
                    <div className="">
                      <div
                        className="form-control p-0 border-0"
                        style={{ width: 200 }}
                      >
                        <Select
                          showSearch
                          placeholder="Branch"
                          filterOption={(input, option) =>
                            option?.label
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          style={{ width: 170, height: 37 }}
                        />
                      </div>
                    </div> */}
                  </div>
                </div>
                <div className="card-body">
                  <div className="table-responsive brand-table">
                    {dataLoading ? (
                      <div className="text-center my-4">
                        <Spin size="large" />
                        <p className="mt-2">Loading data...</p>
                      </div>
                    ) : (
                      <Table
                        columns={payrollColumns}
                        dataSource={processedData}
                        rowKey="key"
                        pgno={true}
                      />
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <CommonFooter />
      </div>
    </div>
  );
};

export default CombinedProcessPayroll;
